import MESSAGES from "@constants/messages.constants";
import { setAlertMessage } from "@reducers/alert.reducer";
import PermissionDeniedComponent from "@screens/permission-denied/permission-denied.component";
import { checkMenuAccess } from "@utils/menu-auth";
import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { useHistory, useLocation } from "react-router-dom";
import { menuUrl } from "../customer-list/model/customer-list.constants";
import { editCustomer } from "./customer-edit.component.service";
import CustomerEditTemplateComponent from "./customer-edit-template.component";
import { getCustomerInputs } from "../model/customer.modal";


const {
  ALERT_TYPES: { SUCCESS, ERROR },
  CUSTOMER_ALERTS: { EDIT_ALERT },
} = MESSAGES;

const CustomerEditComponent = () => {
  const history = useHistory();
  const location = useLocation();
  const dispatch = useDispatch();
  const menuAccess = checkMenuAccess(menuUrl, "write");
  const [formTriggers, setFormTriggers] = useState({
    submitTrigger: 0,
    validationTrigger: 0,
  });

  const handleTriggerClick = (type) => {
    if (type === "SUBMIT") {
      setFormTriggers({
        ...formTriggers,
        submitTrigger: formTriggers.submitTrigger + 1,
      });
    }
  };

  const handleBackClick = () => {
    history.push(`/${menuUrl}`);
  };

  const handleSubmit = async ({ values, errors }) => {
    // INFO : check for errors and return if errors found
    if (errors.length > 0) return;

    // INFO :  construct setting payload
    let customerPayload = {};
    for (let i = 0; i < values.length; i++) {
      customerPayload[values[i].name] = values[i].value;
    }

    // INFO : call create api
    const customerResponse = await editCustomer(
      location?.state?.row?.customer_id,
      customerPayload
    );

    // INFO : check api response and show relevant alert message
    if (customerResponse.status) {
      dispatch(setAlertMessage({ type: SUCCESS, message: EDIT_ALERT }));
      history.push(`/${menuUrl}`);
    } else {
      dispatch(
        setAlertMessage({ type: ERROR, message: customerResponse.message })
      );
    }
  };

  const templateModal = {
    formTriggers,
    formInputs: getCustomerInputs({
      customer_name: location?.state?.row?.customer_name || "",
      email: location?.state?.row?.email || "",
      mobile: location?.state?.row?.mobile || "",
      password: location?.state?.row?.password || "",
      status: location?.state?.row?.status || "",
    }),
  };

  const templateEvents = {
    handleSubmit,
    handleTriggerClick,
    handleBackClick,
  };

  return menuAccess ? (
    <CustomerEditTemplateComponent
      templateModal={templateModal}
      templateEvents={templateEvents}
    />
  ) : (
    <PermissionDeniedComponent />
  );
};

export default CustomerEditComponent;
